/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Col_ContactInputs */

const tr_footer_col_contact = /** @type {(inputs: Footer_Col_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const en_footer_col_contact = /** @type {(inputs: Footer_Col_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_footer_col_contact = /** @type {(inputs: Footer_Col_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_footer_col_contact = /** @type {(inputs: Footer_Col_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Footer_Col_ContactInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const footer_col_contact = /** @type {((inputs?: Footer_Col_ContactInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Col_ContactInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_col_contact(inputs)
	if (locale === "de") return de_footer_col_contact(inputs)
	if (locale === "ru") return ru_footer_col_contact(inputs)
	return tr_footer_col_contact(inputs)
});